import { updatePositions } from "../../../util/methods"
import { initSortable } from "../../../util/sortable"

$(document).on("turbolinks:load", function () {
  var $bundleItemsContainer = $("#js-productBundle-products")

  if ($bundleItemsContainer.length > 0) {
    initSortable(
      $bundleItemsContainer[0],
      ".js-productBundle-item",
      ".draggable-handle",
      function () {
        updatePositions($(".js-productBundle-item:visible"))
      }
    )

    $(".js-productBundle-product-select").each(function () {
      initializeProductSelect(this)
      $(this).on("change", onProductSelectChange)
    })

    $(".js-productBundle-variant-select").each(function () {
      initializeVariantSelect(this)
      $(this).on("change", onVariantSelectChange)
    })

    $(".js-productBundle-version-select").each(function () {
      initializeVersionSelect(this)
    })

    $bundleItemsContainer
      .on("cocoon:after-insert", function (e, $insertedItem) {
        if ($insertedItem.hasClass("js-productBundle-item")) {
          initializeProductSelect(
            $insertedItem.find(".js-productBundle-product-select")[0]
          )
          initializeVariantSelect(
            $insertedItem.find(".js-productBundle-variant-select")[0]
          )
          initializeVersionSelect(
            $insertedItem.find(".js-productBundle-version-select")[0]
          )
          updatePositions($(".js-productBundle-item:visible"))
        }
      })
      .on("cocoon:after-remove", function (e, $removedItem) {
        if ($removedItem.hasClass("js-productBundle-item")) {
          updatePositions($(".js-productBundle-item:visible"))
        }
      })
  }
})

function initializeProductSelect(el) {
  var $el = $(el)
  $el.select2({
    ajax: {
      url: "/api/site/admin/product_bundles/products",
      dataType: "json",
      delay: 250,
      data: function (params) {
        return {
          q: params.term,
          bundle_opt_in: $('input[name="product_opt_in_filter"]:checked').val(),
        }
      },
      processResults: function (data) {
        return {
          results: data.results,
        }
      },
      cache: true,
    },
    minimumInputLength: 3,
    placeholder: "Select a product ...",
    width: "100%",
  })
}

function initializeVariantSelect(el) {
  var $el = $(el)
  var $productSelect = $el
    .closest(".js-productBundle-item")
    .find(".js-productBundle-product-select")
  $el.select2({
    ajax: {
      url: "/api/site/admin/product_bundles/variants",
      dataType: "json",
      delay: 250,
      data: function (params) {
        return {
          q: params.term,
          product_id: $productSelect.val(),
        }
      },
      processResults: function (data) {
        return {
          results: data.results,
        }
      },
      cache: true,
    },
    data: [{ id: "", text: "" }],
    minimumInputLength: 0,
    placeholder: "Select a variant ...",
    width: "100%",
  })
}

function initializeVersionSelect(el) {
  var $el = $(el)
  var $productSelect = $el
    .closest(".js-productBundle-item")
    .find(".js-productBundle-product-select")
  var $variantSelect = $el
    .closest(".js-productBundle-item")
    .find(".js-productBundle-variant-select")
  $el.select2({
    ajax: {
      url: "/api/site/admin/product_bundles/versions",
      dataType: "json",
      delay: 250,
      data: function (params) {
        return {
          q: params.term,
          product_id: $productSelect.val(),
          variant_id: $variantSelect.val(),
        }
      },
      processResults: function (data) {
        return {
          results: data.results,
        }
      },
      cache: true,
    },
    data: [{ id: "", text: "" }],
    minimumInputLength: 0,
    placeholder: "Select a version ...",
    width: "100%",
  })
}

function clearSelect2($select, initializeSelectCallback) {
  $select.val(null).trigger("change")
  $select.html("")
  initializeSelectCallback($select[0])
}

function onProductSelectChange() {
  var $this = $(this)
  var $item = $this.closest(".js-productBundle-item")
  var $variantSelect = $item.find(".js-productBundle-variant-select")
  var $versionSelect = $item.find(".js-productBundle-version-select")

  clearSelect2($variantSelect, initializeVariantSelect)
  clearSelect2($versionSelect, initializeVersionSelect)
}

function onVariantSelectChange() {
  var $this = $(this)
  var $item = $this.closest(".js-productBundle-item")
  var $versionSelect = $item.find(".js-productBundle-version-select")

  clearSelect2($versionSelect, initializeVersionSelect)
}
